import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'

const PaymentErrorModal = ({ isOpen, onClose, errorMessage, errorTitle = "Payment Failed" }) => {
    const handleClose = () => {
        if (onClose) {
            onClose()
        }
    }

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            aria-labelledby="payment-error-dialog-title"
            aria-describedby="payment-error-dialog-description"
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: {
                    borderRadius: '16px',
                    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
                    border: 'none',
                    overflow: 'hidden',
                    margin: '20px'
                }
            }}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <DialogTitle
                id="payment-error-dialog-title"
                style={{
                    textAlign: "center",
                    padding: "32px 32px 16px 32px",
                    backgroundColor: "var(--mainWhite)",
                    borderBottom: "1px solid var(--lightGraySeparator)"
                }}
            >
                <span className="futura_hv_bt_24_28" style={{
                    textAlign: "center",
                    color: "var(--mainRed)",
                    letterSpacing: "-0.5px"
                }}>
                    {errorTitle}
                </span>
            </DialogTitle>
            <DialogContent style={{
                padding: "32px",
                backgroundColor: "var(--mainWhite)"
            }}>
                <DialogContentText
                    id="payment-error-dialog-description"
                    style={{
                        textAlign: "center",
                        margin: 0,
                        lineHeight: "1.6"
                    }}
                >
                    <span className="futura_lt_bt_18_24" style={{
                        color: "var(--mainGrey)",
                        display: "block",
                        marginBottom: "8px"
                    }}>
                        {errorMessage}
                    </span>
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{
                padding: "24px 32px 32px 32px",
                backgroundColor: "var(--mainWhite)",
                borderTop: "1px solid var(--lightGraySeparator)",
                justifyContent: "center"
            }}>
                <button
                    onClick={handleClose}
                    style={{
                        width: "200px",
                        height: "48px",
                        backgroundColor: "var(--mainRed)",
                        color: "var(--mainWhite)",
                        font: "18px/20px Futura Md BT",
                        fontWeight: "600",
                        borderRadius: "8px",
                        textTransform: "none",
                        border: "none",
                        outline: "none",
                        cursor: "pointer"
                    }}
                    autoFocus
                >
                    Try Again
                </button>
            </DialogActions>
        </Dialog>
    )
}

export default PaymentErrorModal
